import { ObservableFromFetch } from "../ObservableFromFetch"
import SubscriptionPlan from "./Model/SubscriptionPlan"

export default function GetSubscriptionPlans() {
  return ObservableFromFetch<SubscriptionPlan[]>("FFOrderSubscriptionPermission/GetSubscriptionPlan")
}